import { SafetyDataContentModel } from './safetyDataContentModel'

export class SafetyDataModel {
  public safetyDataId: number;
  public medicineId: number;
  public storagePlace: string;
  public storagePrecautions: string;
  public shelfLife: string;
  public productHandling: string;
  public productDisposal: string;
  public safetyDataContent: Array<SafetyDataContentModel>;
}